import { connect } from 'react-redux';
import get from 'lodash/get';
import { moderatorActions } from '@lifesize/nucleus';
import { closeInCallModal } from 'actions/InCallModal';
import StopPresenterModal from 'components/StopPresenterModal';

const mapDispatchToProps = (dispatch, ownProps) => ({
  onCancelClicked: () => dispatch(closeInCallModal()),
  onStopClicked: () => {
    dispatch(closeInCallModal());
    if (ownProps.isRemoteModerator) {
      dispatch(moderatorActions.stopParticipantPresentation(get(ownProps, 'participant.participantId')));
    } else {
      dispatch(moderatorActions.stopCurrentConferencePresentation());
    }
  }
});

const mapStateToProps = (state) => ({
  presenter: get(state, 'app.inCallModal.props.participant')
});

export default connect(mapStateToProps, mapDispatchToProps)(StopPresenterModal);
